import { LoadingSpinner } from "../LoadingSpinner";

export const WaitingForBot = () => {
  return (
    <div className="flex h-full flex-col" data-test="waiting-for-bot">
      <div className="flex w-full flex-col space-y-2">
        <div className="flex-grow-0">
          <h2 className="mb-2">&nbsp;</h2>
        </div>
        <div className="flex flex-grow flex-col space-y-8 overflow-hidden">
          <div>
            <div className="py-8">
              <LoadingSpinner reason={"waiting for bot"} delay={0} />
            </div>
            <div
              className="py-8 text-center select-none"
              data-test="waiting-to-join-text"
            >
              Waiting to join…
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
